import { Injectable } from '@angular/core'
import { ApiService } from '@shared/services/api.service'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { ScheduledReportModel, ScheduledReportModelForm, ScheduledReportTemplate } from '@shared/models/scheduled-report.model'

@Injectable({ providedIn: 'root' })
export class ScheduledReportApiService {
  private readonly defaultOptions = { responseType: 'json' }

  constructor(private apiService: ApiService) {}

  template(): Observable<ScheduledReportTemplate> {
    return this.apiService.get<ScheduledReportTemplate>('/scheduled-report/template', this.defaultOptions)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  list(params?: any, eventId?: number): Observable<ScheduledReportModel[]> {
    return (
      this.apiService
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        .get<{ data: ScheduledReportModel[] }>(`/scheduled-report`, { ...this.defaultOptions, params, eventId })
        .pipe(map((response) => response.data))
    )
  }

  get(id: string): Observable<ScheduledReportModel> {
    return this.apiService.get<ScheduledReportModel>(`/scheduled-report/${id}`, this.defaultOptions)
  }

  post(body: ScheduledReportModelForm): Observable<ScheduledReportModel> {
    return this.apiService.post<ScheduledReportModel>(`/scheduled-report`, body)
  }

  patch(id: string, body: Partial<ScheduledReportModelForm>): Observable<ScheduledReportModel> {
    return this.apiService.patch<ScheduledReportModel>(`/scheduled-report/${id}`, body)
  }

  delete(id: string): Observable<void> {
    return this.apiService.delete<void>(`/scheduled-report/${id}`)
  }

  restore(id: string): Observable<ScheduledReportModel> {
    return this.apiService.patch<ScheduledReportModel>(`/scheduled-report/${id}/restore`, {})
  }
}
